import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {playListMediaStore, recentlyMediaStore} from "../../store/MediaStore";
import ContentWrap from "../../components/layout/ContentWrap";
import InfiniteScroll from "react-infinite-scroller";
import Media from "../../components/media/Media";
import {Button, Col, Container, FormControl, InputGroup, Row} from "react-bootstrap";
import Styles from './PlayListView.module.scss'
import {HISTORY, navigate} from "../../helper/HistoryHelper";
import {MagnifyingGlass} from "react-loader-spinner";
import {MdArrowBackIos} from "react-icons/md";
import {TbPencilStar} from "react-icons/tb";
import playListStore from "../../store/PlayListStore";
import SortDropDown from "../../components/media/SortDropDown";

const SORT_TYPE = {
    id: '등록순',
    view: '조회순',
    like: '인기순',
    hate: '비인기순',
    history: '시청순',
    duration: '재생시간순'
}

@observer
class PlayListView extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let {match:{params:{id}}} = this.props;
        let store = playListMediaStore;
        store.scrollRef.current.scrollTo(0, store.scrollTop)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let {match:{params:{id}}} = this.props;
        let store = playListMediaStore;
        if(id !== prevProps.match.params.id){
            store.scrollRef.current.scrollTo(0, 0)
        }
    }

    render() {
        let store = playListMediaStore;
        let playList = store.target;
        return (
            <ContentWrap>

                <div className={Styles.SearchBar}>
                    <Container className={`p-0 d-flex justify-content-between flex-column`}>
                        <div className={Styles.Header}>
                            <div className={Styles.BackButton}
                                 onClick={() => {
                                     HISTORY.goBack();
                                 }}
                            >
                                <MdArrowBackIos color={'#fff'} size={`1.5rem`}/>
                            </div>
                            <div className={Styles.Title}>
                                {playList?.name}
                            </div>
                            <div className={Styles.Button}
                                 onClick={() => {
                                     playListStore.openModify(playList, ()=>this.loadPlayList(playList?.id))
                                 }}
                            >
                                <TbPencilStar color={'#fff'} size={`1.5rem`}/>
                            </div>
                        </div>
                        <div className={`d-flex `}>
                            <div className={`d-flex flex-grow-1 text-nowrap`}>
                                <SortDropDown store={store}
                                              option={SORT_TYPE}
                                />
                            </div>
                            <div>
                                <InputGroup>
                                    <FormControl size={'sm'}
                                                 value={store.keyword}
                                                 onChange={e=>{
                                                     store.keyword = e.target.value
                                                 }}
                                                 onKeyDown={e=>{
                                                     if(e.key === 'Enter') {
                                                         store.searchCondition.set("keyword", store.keyword)
                                                         store.debounceFetch(true);
                                                     }
                                                 }}
                                    />
                                    <Button variant={"outline-light"} size={'sm'}
                                            onClick={()=>{
                                                store.searchCondition.set("keyword", store.keyword)
                                                store.debounceFetch(true);
                                            }}
                                    >
                                        검색
                                    </Button>
                                </InputGroup>
                            </div>
                        </div>
                    </Container>
                </div>
                <div className={Styles.Content}
                     ref={store.scrollRef}
                     onScroll={store.onScrollHandler}
                >
                    <InfiniteScroll
                        loadMore={(page) => {
                            store.debounceFetch(false)
                        }}
                        hasMore={store.files.length < store.count}
                        loader={
                            <div key={"a"}>
                            </div>
                        }
                        useWindow={false}
                        threshold={5}
                    >
                        <Container className={`p-0`}>
                            <Row>
                                {
                                    !store.isFetching && store.files.length < 1 &&
                                    <div className={`align-items-center justify-content-center d-flex p-5`}>
                                    검색 결과가 없습니다.
                                    </div>
                                }
                                {
                                    store.files.map(file => {
                                        return (
                                            <Col sm={12} md={4} xl={3} key={`HOME-${file.id}`}>
                                                <Media file={file}
                                                       onClick={(file) => {
                                                           navigate(`/main/play/list/${playList?.id}/${file?.folder?.id}/${file.id}`)
                                                       }}
                                                />
                                            </Col>
                                        )
                                    })
                                }
                                {
                                    store.isFetching &&
                                    <Col sm={12} md={12} xl={12}
                                         className={`d-flex justify-content-center align-items-center p-5`}>
                                        <MagnifyingGlass
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="magnifying-glass-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="magnifying-glass-wrapper"
                                            glassColor="#c0efff"
                                            color="#afafaf"
                                        />

                                    </Col>
                                }
                            </Row>
                        </Container>
                    </InfiniteScroll>
                </div>
            </ContentWrap>
        );
    }
}

PlayListView.propTypes = {};

export default PlayListView;
